import React from 'react';
import { Logo } from '../Logo';
import { useSidebar } from 'contexts/SidebarContext';

interface SidebarHeaderProps {
  isCollapsed: boolean;
  onToggleCollapse: () => void;
}

export const SidebarHeader: React.FC<SidebarHeaderProps> = ({ isCollapsed, onToggleCollapse }) => {
  const { isMobile, setMobileOpen } = useSidebar();

  return (
    <div className="flex items-center justify-between p-4 border-b border-border h-[64px]">
      {!isCollapsed && (
        <div className="flex-1">
          <Logo variant="small" />
        </div>
      )}
      {isMobile ? (
        <button
          onClick={() => setMobileOpen(false)}
          className="p-1 rounded hover:bg-surface transition-colors"
          aria-label="Close menu"
        >
          <svg className="w-5 h-5 text-text-secondary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      ) : (
        <button
          onClick={onToggleCollapse}
          className="p-1 rounded hover:bg-surface transition-colors"
          aria-label={isCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
        >
          <svg
            className="w-5 h-5 text-text-secondary"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            {isCollapsed ? (
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M13 5l7 7-7 7M5 5l7 7-7 7"
              />
            ) : (
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M11 19l-7-7 7-7m8 14l-7-7 7-7"
              />
            )}
          </svg>
        </button>
      )}
    </div>
  );
};
